<template>
  <div>
    <input
      id="accept-policies"
      name="accept-policies"
      :checked="value"
      :value="acceptPoliciesValue"
      type="checkbox"
      required
      @change="(event) => $emit('input', event.target.checked)"
    />
    <label
      for="accept-policies"
      class="margin-0"
      style="--label-display: inline; --label-font-size: var(--font-size-sm); --link-color: var(--fa-navy)"
    >
      <span
        v-if="isGdprUser"
        class="size-sm"
      >
        I agree to the
        <site-link
          :to="{ name: 'tos' }"
          class="strong"
        >
          Terms of Service</site-link
        >,
        <site-link
          :to="{ name: 'privacy' }"
          class="strong"
        >
          Privacy Policy</site-link
        >
        and
        <site-link
          :to="{ name: 'dpa' }"
          class="strong"
        >
          Data Processing Agreement</site-link
        >.
      </span>
      <span
        v-else
        class="size-sm"
      >
        I agree to the
        <site-link
          :to="{ name: 'tos' }"
          class="strong"
        >
          Terms of Service</site-link
        >
        and
        <site-link
          :to="{ name: 'privacy' }"
          class="strong"
          >Privacy Policy</site-link
        >.
      </span>
    </label>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AcceptPoliciesCheckbox',

    props: {
      value: {
        type: Boolean
      }
    },

    computed: {
      ...mapGetters('cookiePreferences', ['isGdprUser']),

      acceptPoliciesValue() {
        return this.isGdprUser
          ? 'I agree to the Terms of Service, Data Processing Agreement, and Privacy Policy.'
          : 'I agree to the Terms of Service, and Privacy Policy.'
      }
    }
  }
</script>
